import { createContext } from 'react'
import { type Note, NoteType } from '../../utils/note'
import { type SidebarEntry } from '../../modules/sidebar/SidebarBuilder'
import { type useNoteConfig } from '../../hooks/useNote'

export type SidebarProviderContextType = {
  noteKey: useNoteConfig
  handleExportSupabaseTeamspace: (recordName: string) => void
  handleSelectRecordName: (recordName: string) => void
  handleRevealNote: (recordName?: string, range?: Range) => void
  privateProjectNotes: Map<string, Note> | undefined
  privateCalendarNotes: Map<string, Note> | undefined
  privateNotes: Map<string, Note>
  teamProjectNotes: Map<string, Note> | undefined
  teamCalendarNotes: Map<string, Note> | undefined
  teamNotes: Map<string, Note>
  notes: Map<string, Note>
  sidebarEntries: SidebarEntry[]
  createFolder: (noteType?: NoteType, parent?: string | null) => void
  createNote: (noteType?: NoteType, parent?: string | null) => void
  shouldForceUpdateEditor: number
  isInSpecialFolder: (recordName: string | undefined) => boolean
}

export const SidebarContext = createContext<
  SidebarProviderContextType | undefined
>(undefined)
